export enum GameSystems {
  ftl = 1,
  gf = 2,
  gff = 3,
  aof = 4,
  aofs = 5,
  aofr = 6,
  aofq = 7,
  aofqai = 8,
  gfsq = 9,
  gfsqai = 10,
  gfwf = 11
}

export interface IGameSystem {
  id: number;
  slug: string;
  name: string;
  key: string;
  armyBookBuilderEnabled: boolean;
  searchEnabled: boolean;
  engineId: number;
  universeId: number;
  afLoadDisabled?: boolean;
}

export enum GameEngines {
  Core = 1,
  Warfleets = 2
}

export enum Universes {
  grimdark = 1,
  fantasy = 2
}
